import { Datasheet } from "@/api/datasheets";
import { Project } from "@/api/project";
import { SubProject } from "@/api/subProject";
import { WelderRow, WelderWeld } from "@/api/hitachi/rbi";

export type WelderState = {
  project?: Project;
  subProject?: SubProject;
  datasheet?: Datasheet;
  operation?: string;
  welds: WelderWeld[];
  processes: WelderRow[];
  filters: WeldListFilters;
};

export type WeldListFilters = {
  onlyMyWelds: boolean;
  onlyRepairOrRewelds: boolean;
  onlyWeldsNotMade: boolean;
};

export const defaultFilters: WeldListFilters = {
  onlyMyWelds: false,
  onlyRepairOrRewelds: false,
  onlyWeldsNotMade: true,
};

export const defaultState: WelderState = {
  welds: [],
  processes: [],
  filters: defaultFilters,
};

export type StateType = "Project" | "SubProject" | "Datasheet" | "Operation" | "Welds" | "Processes" | "Filters";
